import React from 'react';
import { Switch } from 'ui/common/switch/switch';

import styles from './switch-display-disabled.scss';

export const SwitchDisplayDisabled: React.FC<{
  label: string;
  active: boolean;
  onChange: (value: boolean) => void;
}> = ({
  label, active, onChange
}) => {
    return <div className={`row ${styles.selectSwitchRow}`}>
      <div className={`col-12 ${styles.selectSwitch}`}>
        {label}
        <Switch
          checked={active}
          onChange={onChange} />
      </div>
    </div>;
  };
